import { route } from 'quasar/wrappers'
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

import routes from './routes'

/**
 * vue-router 4, wrapped in Quasar 2's `route()`.
 *
 * Three changes from v3, all forced:
 *   - `new VueRouter(...)` is `createRouter(...)`, and there is no `Vue.use(VueRouter)` -- the router
 *     is a plugin the app installs, which Quasar does for whatever this returns.
 *   - `mode`/`base` are one `history` instance instead of two options. The env vars still come from
 *     quasar.config.js (build.vueRouterMode / build.publicPath), so nothing moves here.
 *   - `scrollBehavior` returns `{ left, top }`; `{ x, y }` is silently ignored.
 *
 * `createMemoryHistory` under SSR: a server render has no browser history to read.
 *
 * The history is chosen inside the factory rather than at module scope (which is where Quasar's own
 * template puts it) so that the env vars are read per call, as `mode`/`base` were.
 */
const historyFactory = () => process.env.SERVER
  ? createMemoryHistory
  : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

export default route(function (/* { store, ssrContext } */) {
  return createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: historyFactory()(process.env.VUE_ROUTER_BASE)
  })
})
